import React from "react";
import { useSelectTheme } from "../../store";

export interface RequiredTagProps {
  style?: React.CSSProperties;
}

export const RequiredTag = (props: RequiredTagProps) => {
  const { color } = useSelectTheme();
  return (
    <div
      css={{
        background: "#EB72570D",
        borderRadius: "5px",
        color: color.warning,
        fontSize: "12px",
        padding: "4px 6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...props.style,
      }}
    >
      Required
    </div>
  );
};
